export const formatSignInData = (data: ISignInData): ISignInData => ({
  ...data,
  email: data.email.toLowerCase(),
});
